import { getPublicAppointmentOrNull } from '../../../api/storefront/storefront';

const toAppointmentSnap = (appointment) => {
  if (!appointment) return null;
  return {
    id: appointment.id,
    exists: () => true,
    data: () => appointment,
  };
};

const clientOwnsAppointment = (appointment, { clientId, clientEmail } = {}) => {
  if (!appointment) return false;
  if (clientId && String(appointment.clientId || '') === String(clientId)) return true;
  const appointmentEmail = String(appointment.clientEmail || '').trim().toLowerCase();
  const scopedEmail = String(clientEmail || '').trim().toLowerCase();
  return Boolean(scopedEmail && appointmentEmail && appointmentEmail === scopedEmail);
};

async function loadOwnedAppointment(companyId, param, clientScope, archived) {
  const paramStr = String(param || '').trim();
  const { clientId, clientEmail } = clientScope || {};
  if (!companyId || !paramStr || (!clientId && !clientEmail)) {
    return null;
  }

  const appointment = await getPublicAppointmentOrNull({ companyId, id: paramStr });
  if (!appointment) return null;
  if (Boolean(appointment.archived) !== Boolean(archived)) return null;
  if (!clientOwnsAppointment(appointment, { clientId, clientEmail })) return null;
  return toAppointmentSnap(appointment);
}

/**
 * Resolves an appointment for the signed-in client portal user.
 */
export async function resolveClientPortalActiveAppointmentSnapshot(
  companyId,
  param,
  clientScope
) {
  return loadOwnedAppointment(companyId, param, clientScope, false);
}

export async function resolveClientPortalArchiveAppointmentSnapshot(
  companyId,
  param,
  clientScope
) {
  return loadOwnedAppointment(companyId, param, clientScope, true);
}

export async function resolveClientPortalAppointmentByParam(companyId, param, clientScope) {
  const active = await resolveClientPortalActiveAppointmentSnapshot(
    companyId,
    param,
    clientScope
  );
  if (active) {
    return { snap: active, isArchived: false };
  }

  const archived = await resolveClientPortalArchiveAppointmentSnapshot(
    companyId,
    param,
    clientScope
  );
  if (archived) {
    return { snap: archived, isArchived: true };
  }

  return null;
}
